// Vendor libraries
import { computed, effect, ElementRef, untracked, signal, viewChild, } from '@angular/core';
import { CdkDrag } from '@angular/cdk/drag-drop';
// Utils / constants
import { GUIDED_WORKFLOWS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
import { SECURITY_ID_REGEX_SOURCE } from 'SecuritiesApp/ts/constants/security-ids.constants';
// Services
import { CookieService } from 'ngx-cookie-service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { GuidedWorkflowsService } from 'GuidedWorkflowsApp/ts/services/guided-workflows.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Components
import { GuidedWorkflowsMenuComponent } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/components/guided-workflows-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "GuidedWorkflowsApp/ts/services/guided-workflows.service";
import * as i5 from "@angular/common";
import * as i6 from "QuickflowsApp/ts/features/quickflows-menu/components/quickflows-menu.component";
import * as i7 from "../../../../../../apps/guided_workflows/static/guided_workflows/ts/features/guided-workflows-menu/components/guided-workflows-menu.component";
import * as i8 from "../../directives/icon/icon.directive";
import * as i9 from "../../directives/popovers/tooltip/tooltip.directive";
import * as i10 from "../../../../../../apps/agent/static/agent/ts/features/agent/components/agent-side-panel/agent-side-panel.component";
import * as i11 from "@angular/cdk/drag-drop";
const _c0 = a0 => ({ "d-none": a0 });
const _c1 = a0 => ({ "side-menu-opened": a0 });
function SideMenuComponent_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("quickflows")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isQuickflowsActive());
    i0.ɵɵproperty("tooltipTitle", "Quickflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-quickflows-color");
} }
function SideMenuComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 9);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("workflows")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isWorkflowsActive());
    i0.ɵɵproperty("tooltipTitle", "Workflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-workflows-color");
} }
function SideMenuComponent_Conditional_0_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 10);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("ai_agent")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.isAIAgentActive());
    i0.ɵɵproperty("tooltipTitle", "AI Agent")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-ai-agent-color");
} }
function SideMenuComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "button", 6);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, SideMenuComponent_Conditional_0_Conditional_7_Template, 3, 6, "div", 7)(8, SideMenuComponent_Conditional_0_Conditional_8_Template, 3, 6, "div", 7)(9, SideMenuComponent_Conditional_0_Conditional_9_Template, 3, 6, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0, ctx_r1.isMenuOpen))("tooltipTitle", "Open Menu")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close-arrow");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1, ctx_r1.isMenuOpen));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipTitle", "Close")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showQuickflows ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.categories.length > 0 && ctx_r1.showWorkflows ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showAgentButton() ? 9 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clearSteps()); });
    i0.ɵɵtext(1, "Back to Workflow Categories");
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 20);
    i0.ɵɵtext(2, "Workflows");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template, 2, 0, "a", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.workflowsMenuComponent && ctx_r1.workflowsMenuComponent.selectedSteps.length > 0 ? 3 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 20);
    i0.ɵɵtext(2, "Quickflows");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 23);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r1.userPreferencesUrl, i0.ɵɵsanitizeUrl)("tooltipTitle", "Quickflows Preferences");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-gear");
} }
function SideMenuComponent_Conditional_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 20);
    i0.ɵɵtext(2, "AI Agent");
    i0.ɵɵelementEnd()();
} }
function SideMenuComponent_Conditional_1_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "a", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "button", 26);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_6_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.toggleDetach()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "button", 27);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_6_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipTitle", ctx_r1.isDetached() ? "Attach Panel" : "Detach Panel");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.isDetached() ? "icon-reattach" : "icon-unattach");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-close");
} }
function SideMenuComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function SideMenuComponent_Conditional_1_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-quickflows-menu", 17);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("displaySecurityId", ctx_r1.displaySecurityId)("securityId", ctx_r1.securityId)("securityName", ctx_r1.securityName)("securityUrl", ctx_r1.securityUrl);
} }
function SideMenuComponent_Conditional_1_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-guided-workflows-menu", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pagePath", ctx_r1.pagePath)("categories", ctx_r1.categories)("selectedSubcategoryId", ctx_r1.selectedSubcategoryId);
} }
function SideMenuComponent_Conditional_1_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-side-panel", 19);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isDetached", ctx_r1.isDetached());
} }
function SideMenuComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtemplate(3, SideMenuComponent_Conditional_1_Conditional_3_Template, 4, 1, "div")(4, SideMenuComponent_Conditional_1_Conditional_4_Template, 5, 3, "div", 14)(5, SideMenuComponent_Conditional_1_Conditional_5_Template, 3, 0, "div", 14)(6, SideMenuComponent_Conditional_1_Conditional_6_Template, 7, 3, "div", 15)(7, SideMenuComponent_Conditional_1_Conditional_7_Template, 2, 1, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SideMenuComponent_Conditional_1_Conditional_8_Template, 1, 4, "ycn-quickflows-menu", 17)(9, SideMenuComponent_Conditional_1_Conditional_9_Template, 1, 3, "ycn-guided-workflows-menu", 18)(10, SideMenuComponent_Conditional_1_Conditional_10_Template, 1, 1, "ycn-agent-side-panel", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("top", ctx_r1.isDetached() ? null : ctx_r1.sidePanelTop, "px")("width", ctx_r1.isDetached() ? ctx_r1.detachedPanelWidth : null, "px");
    i0.ɵɵclassProp("side-panel-ai", ctx_r1.isAIAgentActive())("detached", ctx_r1.isDetached());
    i0.ɵɵproperty("cdkDragDisabled", !ctx_r1.isDetached());
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r1.isDetached() ? "100%" : ctx_r1.sidePanelHeight || "calc(-48px + 100dvh)");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("cursor", ctx_r1.isDetached() ? "grab" : null);
    i0.ɵɵclassProp("bg-panel", ctx_r1.isAIAgentActive());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.type() === "workflows" ? 3 : ctx_r1.type() === "quickflows" ? 4 : ctx_r1.type() === "ai_agent" ? 5 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.isAIAgentActive() ? 6 : 7);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.type() === "quickflows" ? 8 : ctx_r1.type() === "workflows" ? 9 : ctx_r1.type() === "ai_agent" ? 10 : -1);
} }
export class SideMenuComponent {
    onScrollEvent() {
        const sidePanel = this.eltRef.nativeElement.querySelector('.side-panel.open');
        if (sidePanel && window.getComputedStyle(sidePanel).position === 'fixed') {
            this.sidePanelTop = Math.max(0, this.headerHeight - window.scrollY);
        }
        else {
            this.sidePanelTop = undefined;
        }
        this.sidePanelHeight =
            window.scrollY < this.headerHeight ? `calc(100vh - ${this.headerHeight - window.scrollY}px)` : '100vh';
    }
    constructor(eltRef, urlsService, featureService, cookieService, guidedWorkflowsService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.cookieService = cookieService;
        this.guidedWorkflowsService = guidedWorkflowsService;
        this.showQuickflows = true;
        this.cdkDrag = viewChild(CdkDrag);
        this.isSidePanelOpen = signal(false);
        this.isMenuOpen = true;
        this.type = signal('quickflows');
        this.userPreferencesUrl = '';
        this.showWorkflows = false;
        this.categories = [];
        this.selectedSubcategoryId = null;
        this.headerHeight = 48;
        this._isPanelDetached = signal(false);
        this.isDetached = computed(() => {
            const type = this.type();
            const isDetached = this._isPanelDetached();
            return type === 'ai_agent' && isDetached;
        });
        this.savedDragPosition = signal({ x: 0, y: 0 });
        this.detachedPanelWidth = 586;
        this.USER = signal(window.USER);
        this.showAgentButton = computed(() => {
            const user = this.USER();
            return user.groups.includes('agent_testers');
        });
        this.isAIAgentActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'ai_agent';
        });
        this.isQuickflowsActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'quickflows';
        });
        this.isWorkflowsActive = computed(() => {
            const isSidePanelOpen = this.isSidePanelOpen();
            const type = this.type();
            return isSidePanelOpen && type === 'workflows';
        });
        this.displaySecurityId = this.eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
        this.showQuickflows = JSON.parse(this.eltRef.nativeElement.getAttribute('showQuickflows')) ?? true;
        this.pagePath = this.eltRef.nativeElement.getAttribute('pagePath');
        effect(() => {
            const cdkDrag = this.cdkDrag();
            const isDetached = this.isDetached();
            if (cdkDrag && isDetached) {
                const position = untracked(() => this.savedDragPosition());
                position.x = position.x || window.innerWidth - this.detachedPanelWidth - 100;
                cdkDrag.setFreeDragPosition(position);
            }
        });
    }
    ngOnInit() {
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.QUICKFLOWS;
        const hasGuidedWorkflowsFeature = this.featureService.userHasFeatures([GUIDED_WORKFLOWS_FEATURE]);
        const subcategoryCookie = this.cookieService.get(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME) || '""';
        const subcategorySelectedId = JSON.parse(decodeURIComponent(subcategoryCookie));
        const unhashedLocation = window.location.toString().replace('/#/', '/');
        const newURL = new URL(unhashedLocation);
        const queryParams = new URLSearchParams(newURL.search);
        const guidedWorkFlow = queryParams.get('gw');
        const querySubcategoryId = guidedWorkFlow == null || Number.isNaN(guidedWorkFlow) ? null : Number(guidedWorkFlow);
        if (this.pagePath === undefined || this.pagePath === null) {
            this.pagePath = this.getPathName(window.location.pathname);
        }
        this.showWorkflows = hasGuidedWorkflowsFeature;
        if (this.pagePath) {
            this.guidedWorkflowsService.getPageGuidedWorkflows(this.pagePath).subscribe((categories) => {
                this.categories = categories;
                const allSubcategories = categories.reduce((accumulator, category) => accumulator.concat(category.subcategories), []);
                const selectedCategoryId = querySubcategoryId !== null ? querySubcategoryId : subcategorySelectedId;
                this.selectedSubcategoryId =
                    allSubcategories.find((subcategory) => subcategory.id === selectedCategoryId)?.id ?? null;
                if (this.selectedSubcategoryId !== null && !this.isSidePanelOpen()) {
                    this.togglePanel('workflows');
                }
            });
        }
    }
    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
    togglePanel(type) {
        if (this.isSidePanelOpen() && this.type() === 'ai_agent') {
            this.saveDragState();
            if (this.isDetached()) {
                const drag = this.cdkDrag();
                if (drag) {
                    drag.reset();
                }
            }
        }
        if (this.isSidePanelOpen() && this.type() !== type) {
            // Panel is already open with a different type — just switch to the new type
            this.type.set(type);
        }
        else {
            // Panel is closed (open it) or same type clicked (close it)
            this.type.set(type);
            this.isSidePanelOpen.update((isOpen) => !isOpen);
            if (!this.isSidePanelOpen()) {
                this.clearGuidedWorkflowsSubcategoryCookie();
            }
        }
    }
    closeMenu() {
        if (this.type() === 'ai_agent') {
            this.saveDragState();
        }
        this.isSidePanelOpen.set(false);
        this.clearGuidedWorkflowsSubcategoryCookie();
    }
    clearSteps() {
        this.workflowsMenuComponent.clearSteps();
    }
    getPathName(pathname) {
        // Indicators don't use exchange symbols in URLs, but their name in snake case
        const indicatorsIdRegexSource = `(?!indicators(?:/|$))[a-z0-9_]+`;
        // We want to match only if after the ID there is either a slash or the end of the string.
        const securityIdRegex = pathname.includes('/indicators/')
            ? new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE}|${indicatorsIdRegexSource})(/|$)`)
            : new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE})(/|$)`);
        const decodeUriUntilStable = (str) => {
            let lastDecodedStr = str;
            try {
                let currDecodedStr = decodeURIComponent(str);
                // Iterate until decoding no longer changes the string
                while (currDecodedStr !== lastDecodedStr) {
                    lastDecodedStr = currDecodedStr;
                    currDecodedStr = decodeURIComponent(lastDecodedStr);
                }
                return lastDecodedStr;
            }
            catch {
                // If decoding fails for any reason, just return the last successfully decoded string
                return lastDecodedStr;
            }
        };
        // Pathname may be double-url-encoded, so we decode until it doesn't change. If it wasn't double-url-encoded, or
        // even single-url-encoded, decoding multiple times won't hurt.
        const decodedPathname = decodeUriUntilStable(pathname);
        return decodedPathname.replace(securityIdRegex, '/0/').replace(/^\//, '').replace(/\/$/, '');
    }
    toggleDetach() {
        const reattaching = this._isPanelDetached();
        if (reattaching) {
            this.saveDragState();
            const drag = this.cdkDrag();
            if (drag) {
                drag.reset();
            }
        }
        this._isPanelDetached.update((x) => !x);
    }
    saveDragState() {
        const pos = this.cdkDrag()?.getFreeDragPosition();
        if (pos) {
            this.savedDragPosition.set(pos);
        }
    }
    clearGuidedWorkflowsSubcategoryCookie() {
        this.cookieService.delete(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME, '/');
    }
}
SideMenuComponent.ɵfac = function SideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.CookieService), i0.ɵɵdirectiveInject(i4.GuidedWorkflowsService)); };
SideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideMenuComponent, selectors: [["ycn-side-menu"]], viewQuery: function SideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.cdkDrag, CdkDrag, 5);
        i0.ɵɵviewQuery(GuidedWorkflowsMenuComponent, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workflowsMenuComponent = _t.first);
    } }, hostBindings: function SideMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function SideMenuComponent_scroll_HostBindingHandler($event) { return ctx.onScrollEvent($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl", showQuickflows: "showQuickflows", pagePath: "pagePath" }, standalone: false, decls: 2, vars: 2, consts: [["cdkDrag", "", 1, "side-panel", "order-1", "open", 3, "cdkDragDisabled", "top", "width", "side-panel-ai", "detached"], ["ycnTooltip", "", 1, "side-menu-toggler", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["ycnIcon", "", 3, "name"], [1, "side-menu", "order-2", 3, "ngClass"], [1, "side-menu-wrap"], [1, "side-menu-item", "side-menu-item-close"], ["ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "side-menu-item"], ["data-test-id", "quickflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["data-test-id", "workflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["data-test-id", "ai-agent-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["cdkDrag", "", 1, "side-panel", "order-1", "open", 3, "cdkDragDisabled"], [1, "side-panel-wrap"], ["cdkDragHandle", "", 1, "side-panel-header", "bg-gray-base-90"], [1, "d-flex"], [1, "d-flex", "align-items-center"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler"], [1, "side-panel-content", 3, "displaySecurityId", "securityId", "securityName", "securityUrl"], [1, "side-panel-content", 3, "pagePath", "categories", "selectedSubcategoryId"], [1, "d-flex", "flex-column", "flex-auto", "overflow-auto", 3, "isDetached"], [1, "side-panel-title"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline", 3, "click"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent2", "btn-xs", "ml-1", 3, "href", "tooltipTitle"], ["href", "/ai-agent", "ycnTooltip", "", "tooltipTitle", "Go To Full Page", 1, "btn", "btn-circle", "btn-transparent", "btn-xs", "mr-1", "flex-none"], ["ycnIcon", "", "name", "icon-link-arrow"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent", "btn-xs", "mr-1", "flex-none", 3, "click", "tooltipTitle"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "flex-none", 3, "click"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler", 3, "click"]], template: function SideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SideMenuComponent_Conditional_0_Template, 10, 17)(1, SideMenuComponent_Conditional_1_Template, 11, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.USER().authenticated && (ctx.showQuickflows || ctx.showWorkflows && ctx.categories.length || ctx.showAgentButton()) ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isSidePanelOpen() ? 1 : -1);
    } }, dependencies: [i5.NgClass, i6.QuickflowsMenuComponent, i7.GuidedWorkflowsMenuComponent, i8.IconDirective, i9.TooltipDirective, i10.AgentSidePanelComponent, i11.CdkDrag, i11.CdkDragHandle], styles: ["[_nghost-%COMP%] {\n                display: contents;\n            }\n\n            .detached[_ngcontent-%COMP%] {\n                position: fixed;\n                top: auto;\n                right: auto;\n                height: 80vh;\n                border-radius: 8px;\n                box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.3);\n                z-index: 1032;\n                overflow: hidden;\n\n                .side-panel-wrap {\n                    max-height: 100%;\n                    border-radius: 8px;\n                }\n            }"] });
